module.exports = require("/Users/david/vhosts/w85-static-site-starter/gatsby-api/gatsby-browser.ts");